function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 1.5H21.25C21.5261 1.5 21.75 1.72386 21.75 2V7C21.75 7.27614 21.5261 7.5 21.25 7.5H2C1.72386 7.5 1.5 7.27614 1.5 7V2C1.5 1.72386 1.72386 1.5 2 1.5ZM0 2C0 0.89543 0.895431 0 2 0H21.25C22.3546 0 23.25 0.895431 23.25 2V7C23.25 8.10457 22.3546 9 21.25 9H2C0.89543 9 0 8.10457 0 7V2ZM2 11.5H21.25C21.5261 11.5 21.75 11.7239 21.75 12V17C21.75 17.2761 21.5261 17.5 21.25 17.5H2C1.72386 17.5 1.5 17.2761 1.5 17V12C1.5 11.7239 1.72386 11.5 2 11.5ZM0 12C0 10.8954 0.895431 10 2 10H21.25C22.3546 10 23.25 10.8954 23.25 12V17C23.25 18.1046 22.3546 19 21.25 19H2C0.89543 19 0 18.1046 0 17V12ZM19.75 4.5C19.75 5.22487 19.1624 5.8125 18.4375 5.8125C17.7126 5.8125 17.125 5.22487 17.125 4.5C17.125 3.77513 17.7126 3.1875 18.4375 3.1875C19.1624 3.1875 19.75 3.77513 19.75 4.5ZM18.4375 15.8125C19.1624 15.8125 19.75 15.2249 19.75 14.5C19.75 13.7751 19.1624 13.1875 18.4375 13.1875C17.7126 13.1875 17.125 13.7751 17.125 14.5C17.125 15.2249 17.7126 15.8125 18.4375 15.8125Z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#1C1C1C"
});

function SvgOnPrem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnPrem);
export default __webpack_public_path__ + "static/media/OnPrem.b1e49159a103de6f8cb3efd89095f0c6.svg";
export { ForwardRef as ReactComponent };